import { useCallback, useRef, useState } from "react";

const useFileAudioPlayer = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const toggle = useCallback(() => {
    const audio = audioRef.current;
    if (!audio) {
      return;
    }
    if (audio.paused) {
      void audio.play();
    } else {
      audio.pause();
    }
  }, []);

  const seek = useCallback((seconds: number) => {
    setCurrentTime(seconds);
    if (audioRef.current) {
      audioRef.current.currentTime = seconds;
    }
  }, []);

  const handlers = {
    onLoadedMetadata: (event: React.SyntheticEvent<HTMLAudioElement>) =>
      setDuration(event.currentTarget.duration),
    // Whole seconds are all the controls show, so skip the sub-second renders
    onTimeUpdate: (event: React.SyntheticEvent<HTMLAudioElement>) =>
      setCurrentTime(Math.floor(event.currentTarget.currentTime)),
    onPlay: () => setPlaying(true),
    onPause: () => setPlaying(false),
    onEnded: () => {
      setPlaying(false);
      setCurrentTime(0);
    },
  };

  return {
    audioRef,
    handlers,
    ready: duration > 0,
    playing,
    currentTime,
    duration,
    toggle,
    seek,
  };
};

export { useFileAudioPlayer };
